import { DocumentTemplateApi, documentTemplatesApi } from "api/documentTemplatesApi";
import { useEffect, useState } from "react";

export const useDocumentTemplate = (documentTemplateId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<DocumentTemplateApi | null>(null);

  const fetchTemplate = async () => {
    if (!documentTemplateId) {
      console.error("Template id not found.");
      setLoading(false);
      return;
    }
    const res = await documentTemplatesApi.fetchById(documentTemplateId);
    try {
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTemplate();
  }, [documentTemplateId]);

  return { loading, data, refresh: () => fetchTemplate() };
};
